namespace Survey
{
	export class List
		extends ui.tab.TabHTMLPresentation
	{
		private	m_List:	SPA.gui.Listing<Wollmilch.TempSurvey.SurveyObject>;
		private	m_Data:	Wollmilch.TempSurvey.SurveyObject[][];

		public constructor()
		{
			super();

			this.m_Data = new Array();

			this.m_List = new SPA.gui.Listing<Wollmilch.TempSurvey.SurveyObject>(
				new SPA.Survey.data.SurveyTableDataModel(
					{
						header: true,
						headerEnd: true,
						style:
						{
							condense: true,
							stripes: true,
							hover: true
						}
					}
				),
				10,
				( list: SPA.gui.Listing<Wollmilch.TempSurvey.SurveyObject>, count: number, page: number ): void =>
				{
					count = clamp( count, 5, 50 );

					const idx = this.m_Data.findIndex( ( value, index ) => index == page && value !== undefined );

					if ( idx > -1 )
					{
						console.log( 'found page ' + page + ' with index ' + idx );

						list.Content().Data( this.m_Data[ idx ] );
						list.Content().rebuild();

						return;
					}

					new Wollmilch.AJAX(
						{
							url: 'object/list/' + app.getAuthenticationManager().getPerson() + '/limit/' + count + '/page/' + page,
							on:
							{
								success: ( text: string ): void =>
								{
									let obj;
									try
									{
										obj = Wollmilch.jsonize( text );
									}
									catch ( e )
									{
										app.addNotify(
											{
												title: [ ui.h( 3, app.getMessage( 'Survey.ERROR.title' ) ) ],
												body: [ ui.text( app.getMessage( 'Survey.ERROR.no_survey' ) ) ],
												context: 'warning',
												timeout: Number(app.getConfigValue("ToastTimeout"))
											}
										);

										return;
									}

									if ( !obj || !obj.success )
									{
										app.addNotify(
											{
												title: [ ui.h( 3, app.getMessage( 'Survey.ERROR.title' ) ) ],
												body: [ ui.text( app.getMessage( 'Survey.ERROR.no_survey' ) ) ],
												context: 'info',
												timeout: Number(app.getConfigValue("ToastTimeout"))
											}
										);

										return;
									}

									list.Content().Data( obj.data );
									list.Content().rebuild();

									list.SetPage( page, obj.count );

									this.m_Data[ page ] = obj.data;
								}
							}
						},
						Wollmilch.AJAXCallbase_e.TEMPSURVEY
					).send();
				}
			);
		}

		public rebuild( root: JQuery|ui.base.BaseHTMLElement ): List
		{
			super.rebuild( root );

			this.empty();

			this.m_List.rebuild( new ui.Box.Box().appendTo( this ) );

			if ( this.m_Entry )
			{
				this.m_Entry.DeactivateReloadSpin();
			}

			return this;
		}
	}
}
